import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { ApprovalSettings } from '../../models';
import { GroupApprovalService } from './groupApproval.service';

export interface IApprovalSettingsService {
    getAll(): angular.IPromise<ApprovalSettings[]>;
    getAll(force: boolean): angular.IPromise<ApprovalSettings[]>;
    get(guid: string): angular.IPromise<ApprovalSettings>;
    get(guid: string, force: boolean): angular.IPromise<ApprovalSettings>;
    update(guid: string, settings: ApprovalSettings): angular.IPromise<ApprovalSettings>;
}

export class ApprovalSettingsService implements IApprovalSettingsService {
    static serviceId = 'approvalSettingsService';

    private _controllerUrl = 'approvalSettings';

    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<ApprovalSettings[]>;
    getAll(force: boolean): angular.IPromise<ApprovalSettings[]>;
    getAll(force?: any) {
        const url = this._controllerUrl;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url);
    }

    get(guid: string): angular.IPromise<ApprovalSettings>;
    get(guid: string, force: boolean): angular.IPromise<ApprovalSettings>;
    get(guid: string, force?: boolean): angular.IPromise<ApprovalSettings> {
        const url = `${this._controllerUrl}/${guid}`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url);
    }

    update(guid: string, settings: ApprovalSettings): angular.IPromise<ApprovalSettings> {
        return this._requestService.postAtV1<ApprovalSettings>(this._controllerUrl + '/update', { approvalStrategyGuid: guid, approvalSettings: settings })
            .then(data => {
                this._requestService.cleanCacheAtV1(`${GroupApprovalService.urlBase}getTableConfiguration/${guid}`);
                return data;
            });
    }
}